import { render, staticRenderFns } from "./PastGames.vue?vue&type=template&id=6cab2d12&scoped=true"
import script from "./PastGames.vue?vue&type=script&lang=js"
export * from "./PastGames.vue?vue&type=script&lang=js"
import style0 from "./PastGames.vue?vue&type=style&index=0&id=6cab2d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab2d12",
  null
  
)

export default component.exports